import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const internalProjectList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.get('/unit-projects/list', {
        pageSize: state.pageSize,
        pageNumber: state.pageNumber,
        ...query,
      }),
    { pageSize, pageNumber },
  );
};

export const internalProjectAdd = (params) => {
  return _baseClient.post('/unit-projects/save', { body: params }).then((response) => {
    return response;
  });
};

export const internalProjectDelete = (params) => {
  return _baseClient.get('/unit-projects/delete', params);
};

export const internalProjectDetail = (params) => {
  return _baseClient.get('/unit-projects/get', params);
};

export const internalProjectUpdateStatus = (params) => {
  return _baseClient.get('/unit-projects/update-status', params);
};
